export default "__VITE_ASSET__DoiCdr7P__"